import React from "react";
import { Link } from "react-router-dom";
import { logoBase64 } from "./logo";
import styles from "./Header.module.css";

function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.logoContainer}>
        <Link to="/" className={styles.logoLink}>
          <img src={logoBase64} alt="Propertunity Logo" className={styles.logo} />
          <span className={styles.companyName}>Propertunity Careers</span>
        </Link>
      </div>

      <nav className={styles.navLinks}>
        <Link to="/" className={styles.navLink}>Jobs</Link>
        <a
          href="https://propertunityltd.com"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.navLink}
        >
          Main Site
        </a>
      </nav>
    </header>
  );
}

export default Header;
